<template>
  <div>
    <b-container fluid>
      <b-row class="tab-button-row" v-if="id != 'new'">
        <b-col>
          <router-link :to="{ name: 'user-detail' }" tag="button" class="btn">Overzicht</router-link>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'user-detail-edit' }" tag="button" class="btn">Bewerken</router-link>
        </b-col>
      </b-row>

      <b-row v-if="user == null && this.id != 'new'" class="mt-5">
        <b-col class="text-center">
          <b-spinner label="Spinning"></b-spinner>
        </b-col>
      </b-row>
    </b-container>

    <router-view v-if="user != null || this.id == 'new'" :user="user" v-on:refresh="load" />
  </div>
</template>

<script>
  export default {
    name: 'UserDetailContainer',
    data () {
      return {
        user: null,
      }
    },
    props: {
      id: String,
    },
    watch: {
      id () {
        this.load()
      }
    },
    methods: {
      load () {
        this.user = null

        if (this.id == 'new') {
          return
        }

        this.$http.get('users/'+this.id)
          .then(response => {
            this.user = response.data
          })
          .catch((error) => {
            console.log(error)
          });
      }
    },
    mounted () {
      this.load()
    }
  }
</script>